module.exports = __webpack_public_path__ + "static/media/Skill.4eb09b7b.jpg";